import { useAtomValue, useSetAtom } from 'jotai/react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import {
  focusedAccountAtom,
  hasAddedWalletAtom,
  newlyAddedWalletNameAtom,
  walletAccountsAtom,
} from '@/src/stores/accounts/wallets'
import { AccountCardButton } from '../accounts/account-card'
import { Button } from '../ui/button'
import { DialogDescription, DialogTitle } from '../ui/dialog'

export function NewlyAddedWallet({
  onOpenChange,
}: {
  onOpenChange: (open: boolean) => void
}) {
  const { groupedAccounts } = useAtomValue(walletAccountsAtom)
  const setFocusedAccount = useSetAtom(focusedAccountAtom)
  const setHasAddedWallet = useSetAtom(hasAddedWalletAtom)
  const setNewlyAddedWalletName = useSetAtom(newlyAddedWalletNameAtom)

  const pathname = usePathname()

  const StartTradingButtonWrapper = pathname.startsWith('/tokens')
    ? 'div'
    : Link
  const startTradingButtonProps = !pathname.startsWith('/tokens')
    ? {
        href: '/tokens?ticker=OSMO',
      }
    : {}

  return (
    <>
      <div className='flex flex-col items-center justify-center'>
        <div className='flex flex-col gap-3'>
          <DialogTitle className='font-serif font-extralight'>
            Ready to trade?
          </DialogTitle>
          <DialogDescription className='pb-8 text-base'>
            Start trading or add more wallets.
          </DialogDescription>
        </div>
        {groupedAccounts.length === 1 ? (
          <AccountCardButton
            account={groupedAccounts[0]}
            className='min-w-[248px]'
            onClick={() => {
              setFocusedAccount(groupedAccounts[0])
            }}
          />
        ) : groupedAccounts.length > 1 ? (
          <div className='grid grid-cols-2 gap-2'>
            {groupedAccounts.slice(-4).map((account) => (
              <AccountCardButton
                key={account.grouping_key}
                account={account}
                className='min-w-[188px]'
                onClick={() => {
                  setFocusedAccount(account)
                }}
              />
            ))}
          </div>
        ) : null}
      </div>
      <div className='flex items-center gap-2 p-8'>
        <Button
          type='button'
          variant='secondary'
          className='w-full font-semibold'
          onClick={() => {
            setHasAddedWallet(false)
            setNewlyAddedWalletName(null)
          }}
        >
          Add more
        </Button>
        <StartTradingButtonWrapper
          className='w-full'
          href={startTradingButtonProps.href!}
        >
          <Button
            type='button'
            variant='primary'
            className='w-full font-semibold'
            onClick={() => {
              onOpenChange(false)
              setHasAddedWallet(false)
              setNewlyAddedWalletName(null)
            }}
          >
            Start trading
          </Button>
        </StartTradingButtonWrapper>
      </div>
    </>
  )
}
